export const CONFIG_FETCHER_ACTIONS = {
  FETCH_CONFIG_DATA_SUCCESS: "FETCH_CONFIG_DATA_SUCCESS",
  FETCH_CONFIG_DATA_ERROR: "FETCH_CONFIG_DATA_ERROR",
  FETCH_COLOR_PALETTE_DATA_SUCCESS: "FETCH_COLOR_PALETTE_DATA_SUCCESS",
  FETCH_COLOR_PALETTE_DATA_ERROR: "FETCH_COLOR_PALETTE_DATA_ERROR"
};
